import React from 'react'
import styled from 'styled-components'
import { groupBy } from 'lodash'
import { Alert, CollapsiblePanel, Divider } from 'components'
import MatchingField from 'features/forms/components/MatchingField'
import { colors, _ } from 'utils'
import { GroupMappedFields, MappedField } from './types'

const S = {
    Wrapper: styled.div``,
    Header: styled.div`
        display: grid;
        margin-top: 32px;
        margin-bottom: 10px;
        grid-template-columns: repeat(3, 1fr);
        font-weight: 500;
        font-size: 12px;
        text-transform: uppercase;
        color: ${colors.iconOpacity(0.75)};
    `,
    Note: styled.p`
        font-weight: 300;
        font-size: 16px;
        color: ${colors.grayDescription};
    `,
}

interface Props {
    groups?: GroupMappedFields
    fields: MappedField[]
    errorFields?: string[]
    columns: string[]
}

const RenderFields = ({
    groups, fields, columns = [], errorFields
}: Props) => {
    const getDefaultValue = (field = '') => {
        const value = columns.find((e) => e.toLowerCase().includes(field.toLowerCase()))
        if (!value) {
            return undefined
        }

        return { value, label: value }
    }

    const renderFields = (_fields = []) => (
        <>
            {_fields.map((field, i) => (
                <>
                    <MatchingField
                        label={field.label}
                        name={field.field}
                        options={columns.map((e) => ({ value: e, label: e }))}
                        isRequired={field.isRequired}
                        isClearable={!field.isRequired}
                        key={field.field}
                        error={errorFields.includes(field.field)}
                        defaultValue={getDefaultValue(field.label)}
                    />
                    {i < _fields.length - 1 && <Divider key={i} extend={0} style={{ marginBottom: 10 }} />}
                </>
            ))}
        </>
    )

    if (groups?.length) {
        const groupedFields = groupBy(fields, 'groupId')

        return (
            <>
                {groups.map((group) => (
                    <CollapsiblePanel
                        title={group.text}
                        className="mt-4"
                        key={group.id}
                        counter={groupedFields[group.id]?.length}
                    >
                        {renderFields(groupedFields[group.id])}
                    </CollapsiblePanel>
                ))}
            </>
        )
    }

    return renderFields(fields)
}

const MatchingFieldsTable = (props: Props) => (
    <S.Wrapper>
        <S.Note>{_('import_file.matching_fields_note')}</S.Note>
        <Alert text={_('import_file.matching_fields.description')} variant="info" />

        <S.Header>
            <span>Fields</span>
            <span>Match with</span>
            <span>Extenal field name</span>
        </S.Header>

        <RenderFields {...props} />
    </S.Wrapper>
)

export default MatchingFieldsTable
